import * as actionTypes from './actiontypes'
import * as API from './api'
import { startPageLoading, stopPageLoading } from '../page_details/actions'
import { log } from '../../config/utils'

export const updateApiLogsState = payload => {
  return {
    type: actionTypes.UPDATE_APILOGS_STATE,
    payload
  }
}

export const updateApiLogsSelectedFilters = payload => {
  return {
    type: actionTypes.UPDATE_APILOGS_SELECTED_FILTERS,
    payload
  }
}

export const getApilogsList = (payload, callback) => dispatch => {
  log("getApilog paylod", payload)
  dispatch(startPageLoading('Loading'))
  API.getApilogsList(payload, (error, response) => {
    log('getAPILogsList', response)
    dispatch(stopPageLoading())
    if (!error && response && response.data && response.data.apiResponseList) {
      dispatch({
        type: actionTypes.APILOGS_LOADED,
        payload: response.data.apiResponseList,
      })
      if (callback) callback(response.data.apiResponseList)
    }
  })
}

export const loadMoreApiLogs = payload => {
  return dispatch => {
    API.getApilogsList(payload, (error, response) => {
      log('loadMore getApilogsList', response)
      if (!error && response && response.data && response.data.apiResponseList) {
        dispatch({
          type: actionTypes.MORE_APILOGS_RECEIVED,
          payload: response.data.apiResponseList,
        })
      }
    })
  }
}

export const getApiLogDetails = payload => dispatch => {
  dispatch(startPageLoading('Loading'))
  API.getApiLogDetails(payload, (error, response) => {
    log('getApiLogDetails response', response)
    dispatch(stopPageLoading())
    if (!error && response && response.data && response.data.apiResponseData) {
      dispatch(
        updateApiLogsState({
          selected_api: {
            id: payload.id,
            response_data: response.data.apiResponseData
          }
        })
      )
    }
  })
}



// WEBPACK FOOTER //
// ./src/data/redux/apilogs_details/actions.js